export enum QUERY_KEYS {
  VIEW = 'VIEW',
  VIEWS = 'VIEWS',
}

export default QUERY_KEYS
